/**
 * Size guide: tab switching and inch/cm switching.
 *
 * Everything is delegated off the document so it works for markup that appears after load — the PDP chart lives inside
 * an <x-modal> and the landing page section is re-rendered wholesale by the theme editor.
 */
(function () {
  if (window.__petitePlumeSizeGuide) return;
  window.__petitePlumeSizeGuide = true;

  const TAB = '[role="tab"]';
  const TABS = '[data-sg-tabs]';
  const CHART = '[data-sg-chart]';

  function tabsIn(root) {
    return Array.from(root.querySelectorAll(TAB));
  }

  function selectTab(tab) {
    const root = tab.closest(TABS);
    if (!root) return;

    tabsIn(root).forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', selected ? 'true' : 'false');
      other.setAttribute('tabindex', selected ? '0' : '-1');

      const panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });

    // The PDP modal heading changes with the active tab ("Size Guide" / "How to Measure").
    const heading = root.querySelector('[data-sg-title-target]');
    const title = tab.getAttribute('data-sg-title');
    if (heading && title) heading.textContent = title;
  }

  function selectUnit(button) {
    const chart = button.closest(CHART);
    if (!chart) return;

    const unit = button.getAttribute('data-sg-unit');

    chart.querySelectorAll('[data-sg-unit]').forEach((other) => {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    });

    chart.querySelectorAll('[data-sg-unit-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-sg-unit-panel') !== unit;
    });
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(TAB);
    if (tab && tab.closest(TABS)) {
      event.preventDefault();
      selectTab(tab);
      return;
    }

    const unit = event.target.closest('[data-sg-unit]');
    if (unit && unit.closest(CHART)) {
      event.preventDefault();
      selectUnit(unit);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    const tab = event.target.closest(TAB);
    const root = tab && tab.closest(TABS);
    if (!root) return;

    const all = tabsIn(root);
    const step = event.key === 'ArrowRight' ? 1 : -1;
    const next = all[(all.indexOf(tab) + step + all.length) % all.length];

    event.preventDefault();
    selectTab(next);
    next.focus();
  });
})();
